export const getters = {
    profileInfo: state => state.profileInfo,
    editProfileInfo: state => state.editProfileInfo,
    profileAvatar: state => state.profileAvatar,
    hasHeadingAvatarLoaded: state => state.hasHeadingAvatarLoaded,
    notificationsStatus: state => state.notificationsStatus
};


// WEBPACK FOOTER //
// ./src/store/modules/profile/getters.js